import axios from 'axios';

let providerData = [];


// Try multiple approaches to load the providers
const loadProviders = async () => {
	const paths = [
		'/assets/providers.json',
		`${window.location.origin}/assets/providers.json`,
		'./assets/providers.json'
	];
	
	for (const path of paths) {
		
		try {
			const response = await fetch(path);
			
			if (response.ok) {
				const data = await response.json();
				
				if (data && data.providers) {
					providerData = [...data.providers];
					return; 
				} else {
					console.warn('No providers array found in response');
				}
			} else {
				console.error(`Fetch failed with status: ${response.status}`);
			}
		} catch (fetchError) {
			console.error(`Fetch error for ${path}:`, fetchError.message);
			
			// Fallback to axios
			try {
				const axiosResponse = await axios.get(path);
				
				if (axiosResponse.data && axiosResponse.data.providers) {
					providerData = [...axiosResponse.data.providers];
					return; 
				}
			} catch (axiosError) {
				console.error(`Axios error for ${path}:`, axiosError.message);
				console.error('Status:', axiosError.response?.status);
			}
		}
	}
	
};

// Load providers
loadProviders().catch(err => {
	console.error('Fatal error loading providers:', err);
});

export { providerData };
